// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  token: __t.string(),
  orgId: __t.string().name("org_id"),
  projectId: __t.string().name("project_id"),
  jobId: __t.string().name("job_id"),
  label: __t.string(),
  allowComments: __t.bool().name("allow_comments"),
  createdByName: __t.string().name("created_by_name"),
  createdAt: __t.timestamp().name("created_at"),
  expiresAt: __t.option(__t.timestamp()).name("expires_at"),
  revoked: __t.bool(),
  versions: __t.string(),
  allowDecisions: __t.bool().name("allow_decisions"),
  hasPassword: __t.bool().name("has_password"),
  scopeId: __t.string().name("scope_id"),
  assetId: __t.string().name("asset_id"),
  createdByUserId: __t.string().name("created_by_user_id"),
});
